import { render, staticRenderFns } from "./PolizaHogar.vue?vue&type=template&id=974c8464&scoped=true&"
import script from "./PolizaHogar.vue?vue&type=script&lang=js&"
export * from "./PolizaHogar.vue?vue&type=script&lang=js&"
import style0 from "./PolizaHogar.vue?vue&type=style&index=0&id=974c8464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974c8464",
  null
  
)

export default component.exports